import { FormControl, FormGroup, Validators } from '@angular/forms';
import { OneDxMaterialItem } from '../../shared/models/onedx.model';

export interface StandardDealForm {
    quoteNumber: string;
    materials: OneDxMaterialItem[];
}

export interface StandardDealFormGroup {
    quoteNumber: FormControl<string | null>;
    materials: FormControl<OneDxMaterialItem[]>;
}

export const createStandardDealFormGroup = (): FormGroup<StandardDealFormGroup> => {
    return new FormGroup<StandardDealFormGroup>({
        quoteNumber: new FormControl<string | null>(null, Validators.required),
        materials: new FormControl<OneDxMaterialItem[]>([], { nonNullable: true })
    });
};
